import { NgTemplateOutlet } from '@angular/common';
import { SwiperOptions } from 'swiper/types';
import { Subscription } from 'rxjs';

import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding,
  Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation
} from '@angular/core';

import {
  DeviceService, IExtendedLink, ILinkMedia, IPushCardWithLayout, ISliderInfo, SdPushCardComponent, SdThemeComponent, SizesEnum
} from '@seb/web-design-system/core';

import { SdShowMoreComponent } from '@seb/web-design-system/show-more';
import { SdSliderComponent } from '@seb/web-design-system/sliders';

@Component({
  selector: 'sd-push-slider',
  templateUrl: './push-slider.component.html',
  styleUrls: ['./push-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdSliderComponent,
    SdShowMoreComponent,
    NgTemplateOutlet,
    SdPushCardComponent
  ]
})
export class SdPushSliderComponent extends SdThemeComponent implements OnInit, OnDestroy {
  /** @TODO: space between might be problematic if brand decided to use
   * a different brand--ratio, see if it's possible to map it on a css value
   * We can now use css-variable !! use it
   */
  @Input()
  pushSliderConfig: SwiperOptions = {
    pagination: {
      dynamicBullets: false,
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        spaceBetween: 20,
        slidesPerView: 'auto'
      },
      768: {
        spaceBetween: 20
      },
      1280: {
        spaceBetween: 20
      }
    }
  };

  @Input()
  isLoading = false;

  @Input()
  context = 'Push slider';

  @Input()
  pushs: IPushCardWithLayout[];

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel = 3;

  /**
   * Allow to define which push size will be set on the slider
   */
  @Input()
  size: SizesEnum;

  /**
   * If true, it's not a slider
   */
  @Input()
  hasReadMore = false;

  @Input()
  twicPicsAutoSize = true;

  @ViewChild('pushSlider')
  pushSlider: SdSliderComponent;

  @Output()
  clicked = new EventEmitter<any>();

  @Output()
  videoPlayed = new EventEmitter<{ status: string; title: string }>();

  @Output()
  videoEnded = new EventEmitter<{ status: string; title: string }>();

  @Output()
  itemsRule = new EventEmitter<ISliderInfo>();

  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.hasReadMore ? 'has-read-more' : '',
      this.size ? 'is-size-' + this.size : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  numItemVisible = 1;
  subscriptions = new Subscription();
  isTablet$: boolean;
  isMobile$: boolean;

  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.deviceService.isTablet.subscribe((x) => {
        this.isTablet$ = x;
        this.cdRef.markForCheck();
      })
    );

    this.subscriptions.add(
      this.deviceService.isMobile.subscribe((x) => {
        this.isMobile$ = x;
        if (this.hasReadMore) {
          this.numItemVisible = this.isMobile$ ? 1 : 2;
        } else {
          this.numItemVisible = 1;
        }
        this.cdRef.markForCheck();
      })
    );

    this.pushSliderConfig = {
      pagination: {
        dynamicBullets: false,
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        0: {
          spaceBetween: 20,
          slidesPerView: 'auto'
        },
        768: {
          spaceBetween: 20
        },
        1280: {
          spaceBetween: 20
        }
      }
    };
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onSlideChange(event: ISliderInfo): void {
    this.itemsRule.emit(event);
  }

  onClick(event: IExtendedLink | ILinkMedia, title?: string): void {
    this.clicked.emit({ link: event, isBrandCorner: !!this.brand, title });
  }

  onVideoPlayed(item?: IPushCardWithLayout): void {
    this.videoPlayed.emit({
      status: 'play',
      title: item?.push?.richParagraph?.heading?.data?.title
    });
  }

  onVideoEnded(item?: IPushCardWithLayout): void {
    this.videoEnded.emit({
      status: 'ended',
      title: item?.push?.richParagraph?.heading?.data?.title
    });
  }
}
